import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// layout
import { LayoutDefaultComponent } from '../layout/default/default.component';
import { FullscreenComponent } from '../layout/fullscreen/fullscreen.component';

// pages
import { DashboardsComponent } from './dashboards/dashboards.component';
import { DataSourcesComponent } from './data-sources/data-sources.component';
import { TeamsHealthComponent } from './teams-health/teams-health.component';
import { LoginComponent } from './login/login.component';
import { MarketPlaceComponent} from './market-place/market-place.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { PlaygroundRegisterComponent } from './playground-register/playground-register.component';
import { ProfileComponent} from './profile/profile.component';
import { ProjectCardComponent} from './project-card/project-card.component';
import { RegisterComponent } from './register/register.component';
import { ResultComponent } from './result/result.component';
import { VersionComponent } from './version/version.component';
import { HomeComponent } from "./home/home.component";

// guards
import { AuthGuard } from '@core/security/auth.guard';
import { FeatureToggleGuard } from '@core/security/feature-toggle.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';

import { UserRoleEnum } from '@shared/enums/user-role.enum';

const routes: Routes = [
  {
    path: '',
    component: LayoutDefaultComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: [UserRoleEnum.ROLE_ADMIN, UserRoleEnum.ROLE_USER, UserRoleEnum.ROLE_EXECUTIVE_GROUP],
            redirectTo: 'admin'
          }
        }
      },
      {
        path: 'dashboards',
        component: DashboardsComponent,
        data: {
          permissions: {
            only: [UserRoleEnum.ROLE_SUPERUSER],
            redirectTo: 'home'
          }
        }
      },
      {
        path: 'market-place',
        component: MarketPlaceComponent
      },
      {
        path: 'data-sources',
        component: DataSourcesComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: [UserRoleEnum.ROLE_ADMIN, UserRoleEnum.ROLE_SUPERUSER],
            redirectTo: '/'
          }
        }
      },

      {
        path: 'organization',
        loadChildren: () => import('./executive-dashboards/executive-dashboards.module').then(m => m.ExecutiveDashboardsModule),
      },

      {
        path: 'teams-health',
        component: TeamsHealthComponent
      },
      { path: 'project-card/:id',
        component: ProjectCardComponent },

      {
        path: 'profile/:id',
        component: ProfileComponent

      },
      {
        path: 'scorecard',
        loadChildren: () => import('./scorecard/scorecard.module').then(m => m.ScorecardModule),
        canActivate: [FeatureToggleGuard]
      },
      {
        path: 'gitwiser',
        loadChildren: () => import('./gitwiser/gitwiser.module').then(m => m.GitwiserModule)
      },
      {
        path: 'dashboards',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'quality',
        loadChildren: () => import('./q-wiser/q-wiser.module').then(m => m.QWiserModule)
      },
      {
        path: 'agile-space',
        loadChildren: () => import('./agile-space/agile-space.module').then(m => m.AgileSpaceModule)
      },
      {
        path: 'portfolio',
        loadChildren: () => import('./portfolio/portfolio.module').then(m => m.PortfolioModule)
      },
      {
        path: 'leagues',
        loadChildren: () => import('./leagues/leagues.module').then(m => m.LeaguesModule)
      },
      {
        path: 'gamification',
        loadChildren: () => import('./gamification/gamification.module').then(m => m.GamificationModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
        canActivate: [FeatureToggleGuard, NgxPermissionsGuard],
        data: {
          permissions: {
            only: [UserRoleEnum.ROLE_ADMIN, UserRoleEnum.ROLE_SUPERUSER],
            redirectTo: '/'
          }
        }
      },
      { path: '401', component: ResultComponent },
      { path: '403', component: ResultComponent },
      { path: '404', component: ResultComponent }
    ]
  },
  {
    path: '',
    component: FullscreenComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: 'password-change', component: PasswordChangeComponent },
      {
        path: 'register',
        component: RegisterComponent,
        data: { root: true }
      },
      {
        path: 'version',
        component: VersionComponent
      }
    ]
  },
  { path: 'playground-register', component: PlaygroundRegisterComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class RoutesRoutingModule {}
